var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9656 43.9941L45.9658 40.1265V30.9954C46.0498 27.4398 41.8042 24.2701 37.9666 20.9964M41.0043 34.995L35.9028 29.7816C35.2838 29.1373 34.3671 28.8741 33.5006 29.0919C32.6341 29.3097 31.9507 29.975 31.7099 30.8354C31.469 31.6958 31.7077 32.6192 32.3352 33.2552L37.9666 38.9946V41.9944C38.2729 43.7833 38.9544 45.4872 39.9664 46.9939M1.97021 3.99814L3.97002 7.86576V16.9968C3.88602 20.5525 8.1316 23.7222 11.9692 26.9958M8.93152 12.9972L14.033 18.2107C14.652 18.855 15.5688 19.1182 16.4353 18.9004C17.3018 18.6826 17.9852 18.0173 18.226 17.1569C18.4668 16.2965 18.2282 15.3731 17.6007 14.7371L11.9692 8.99765V5.99794C11.663 4.20897 10.9814 2.5051 9.96942 0.998444M11.9692 16.1009V45.9939C11.9692 46.5462 12.4169 46.9939 12.9691 46.9939H34.9669M22.9681 4.99804H15.9688M37.9666 31.8914V19.9965M26.9677 30.9954H15.9688M33.967 24.996H15.9688M24.9679 36.9949H15.9688M41.9662 8.99765C41.9662 13.4155 38.3849 16.9968 33.967 16.9968C29.5492 16.9968 25.9678 13.4155 25.9678 8.99765C25.9678 4.57981 29.5492 0.998444 33.967 0.998444M41.9662 2.99824L34.6749 10.2895C34.4874 10.4776 34.2326 10.5833 33.967 10.5833C33.7014 10.5833 33.4467 10.4776 33.2591 10.2895L30.9673 7.99774",
    stroke: "#EF9C66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControl);
export default __webpack_public_path__ + "static/media/control.e18043dce0cdf36fa79d7d3a7cdfd07d.svg";
export { ForwardRef as ReactComponent };